/* Elements link to header dropdown */
document.querySelectorAll('.section-logo-list a[href^="#link"]').forEach(function(logolink) {
    logolink.addEventListener("click", function(e) {
      e.preventDefault();
      var element_link = this.getAttribute("href");
      document.querySelector('.bottom-header--primary-navigation .mobile-prime-menu ' + element_link).click();
    });
});
/* Elements link to header dropdown */

/* Mobile Menu */
document.querySelectorAll('.link_title-mobile>svg').forEach(function(closeIcon) {
  closeIcon.addEventListener("click", function() {
    var openMenu = this.closest('nav').querySelectorAll('details[open]');
    var openSubMenu = this.closest('nav').querySelectorAll('.list-menu--disclosure>li');
    openMenu.forEach(function(openItem) {
      openItem.removeAttribute('open');
    });
    openSubMenu.forEach(function(openSubItem) {
      if (openSubItem.classList.contains('inactive-item')) {
        openSubItem.classList.remove('inactive-item');
      } else if (openSubItem.classList.contains('submenu-active')) {
        openSubItem.classList.remove('submenu-active');
      }
    });
    if (document.querySelector('body').classList.contains('overflow-hidden-tablet')) {
      document.querySelector('body').classList.remove('overflow-hidden-tablet');
    }
    if (document.querySelector('body').classList.contains('overflow-hidden')) {
      document.querySelector('body').classList.remove('overflow-hidden');
    }
  });
});

document.querySelectorAll('.header__submenu .header__menu-item ').forEach(function(menuItem) {
  menuItem.addEventListener("click", function(e) {
    var otherItem = this.closest('ul').querySelectorAll('.list-menu--disclosure>li');
    otherItem.forEach(function(item) {
      if(!item.contains(e.target)) {
        if(!item.classList.contains('link_title-mobile')) {
          item.classList.add('inactive-item');
          item.querySelectorAll('details[open]').forEach(function(el) {
            el.removeAttribute('open');
          });
        } else {
          item.classList.add('submenu-active');
        }
      } else {
        if(item.classList.contains('inactive-item')) {
          item.classList.remove('inactive-item');
        }
      }
    });
  });
});

document.querySelectorAll('.link_title-mobile>span>svg').forEach(function(submenuClose) {
  submenuClose.addEventListener("click", function() {
    var activeSubmenu = this.closest('ul').querySelector('.list-menu--disclosure>li:not(.inactive-item) details[open]');
    var inactiveSubmenu = this.closest('ul').querySelectorAll('.list-menu--disclosure>li.inactive-item');
    activeSubmenu.removeAttribute('open');
    inactiveSubmenu.forEach(function(item) {
      item.classList.remove('inactive-item');
    });
    this.closest('li').classList.remove('submenu-active');
  });
});

if (document.querySelector('.menu-drawer__menu').classList.contains('bottom-header-sync')) {
  document.querySelectorAll('.bottom-header-sync .list-menu__primary-item').forEach(function(item) {
    item.addEventListener("click", function(e) {
      e.preventDefault();
      var linkitem = this.closest('li').getAttribute('link-index');
      document.querySelector('.bottom-header--primary-navigation .list-menu--inline.mobile-prime-menu>li[link-index="' + linkitem + '"] .list-menu__primary-item').click();
      this.closest('.menu-opening').removeAttribute('open');
    });
  });
}

if (window.innerWidth < 989) {
  document.querySelectorAll('.bottom-header--primary-navigation .list-menu__primary-item').forEach(function(primaryMeu) {
    primaryMeu.addEventListener("click", function() {
      let parentOpen = this.closest('details');
      if (parentOpen.hasAttribute('open')) {
        document.querySelector('body').classList.remove('overflow-hidden');
        if (document.querySelector('body').classList.contains('overflow-hidden-tablet')) {
          document.querySelector('body').classList.remove('overflow-hidden-tablet');
        }
      } else {
        document.querySelector('body').classList.add('overflow-hidden');
      }
    });
  });

  function iOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  if (iOS()) {
    document.querySelector('body').classList.add('ios-device');
  }
}
/* End Mobile Menu */

/* Secondary Menu Drawer */
document.onclick = function(evnt) {
  if (!document.querySelector('.secondary-menu-drawer').contains(evnt.target)) {
    if(document.querySelector('.secondary-menu-drawer').querySelector('details[open]') != null) {
      document.querySelector('.secondary-menu-drawer').querySelector('details[open]').removeAttribute('open');
    }
  }
}
/* End Secondary Menu Drawer */

/* Clicking on image changes Variant */
class imageThumbnail extends HTMLElement {
  constructor() {
    super();
    this.checkOptions();
  }

  checkOptions() {
    const variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.querySelectorAll('.product-image-thumbnail li').forEach(function(thumbnailImg) {
      thumbnailImg.addEventListener("click", function(e) {
        var thumbName = this.getAttribute('thumbnail-media-id');
        this.option = variantData.find(variant => variant.featured_media.id == thumbName);
        const variantFieldsets = document.querySelector('variant-radios').querySelectorAll('fieldset');
        if(this.option !== undefined) {
          for (let i = 0; i < this.option.options.length; i++) {
            var radiovar = variantFieldsets[i].querySelectorAll('input');
            for (let n = 0; n < radiovar.length; n++) {
              if (radiovar[n].value == this.option.options[i]) {
                radiovar[n].click();
              }
            }
          }
        }
      });
    });
  }
}
customElements.define('product-media-thumbnail', imageThumbnail); 
